import { FC } from 'react';
import type { SolveResultFormat } from 'state/quotes/results/result.model';

import { useFormattedResult } from './useFormattedResult';

export const SolveResult: FC<{ value: number; format: SolveResultFormat }> = ({ value, format }) => {
  const resultText = useFormattedResult(value, format);
  return (
    <div className="d-flex">
      <span className="d-none d-lg-flex text-figures display-3" data-e2e="solve-result">
        {resultText}
      </span>
      <span className="d-block d-lg-none text-figures display-4" data-e2e="solve-result">
        {resultText}
      </span>
      <span className="align-self-end display-5 ms-1">{format === 'Percent' ? '%' : ''}</span>
    </div>
  );
};

SolveResult.displayName = 'SolveResult';
